const map = {
	"./components/footer.json": [
		49349,
		[
			9349
		]
	],
	"./components/index.json": [
		20041,
		[
			2422
		]
	],
	"./components/navigation.json": [
		940,
		[
			940
		]
	],
	"./factsheet/asthma.json": [
		43293,
		[
			3293
		]
	],
	"./factsheet/common-cold.json": [
		39919,
		[
			9919
		]
	],
	"./factsheet/croup.json": [
		94786,
		[
			2405
		]
	],
	"./factsheet/factsheet.json": [
		52064,
		[
			2064
		]
	],
	"./media-release/media-release.json": [
		36760,
		[]
	],
	"./media-release/media_release-bulk-billed-gp-telehealth-consultations-break-cost-and-access-barriers-to-mental-health-services.json": [
		37458,
		[
			7458
		]
	],
	"./media-release/media_release-digital-healthcare-model-can-ease-pressure-on-gps.json": [
		27568,
		[
			7568
		]
	],
	"./media-release/media_release-free-telehealth-services-for-flood-ravaged-town-of-eugowra.json": [
		28007,
		[
			8007
		]
	],
	"./media-release/media_release-increased-telehealth-usage-could-help-solve-national-gp-shortage.json": [
		70107,
		[
			107
		]
	],
	"./media-release/media_release-instantscripts-donates-10000-to-qld-helicopter-crash-family.json": [
		18608,
		[
			8608
		]
	],
	"./media-release/media_release-instantscripts-responds-to-medical-board-of-australias-revised-telehealth-guidelines.json": [
		39212,
		[
			9212
		]
	],
	"./media-release/media_release-instantscripts-to-be-acquired-by-wesfarmers-health.json": [
		13512,
		[
			3512
		]
	],
	"./media-release/media_release-making-mental-health-treatment-plans-more-accessible-via-telehealth.json": [
		78894,
		[
			8894
		]
	],
	"./pages/blood-pressure-monitor.json": [
		92399,
		[
			2399
		]
	],
	"./pages/childrens-doctor-online.json": [
		56108,
		[
			6108
		]
	],
	"./pages/chlamydia.json": [
		91104,
		[
			1104
		]
	],
	"./pages/contact-us.json": [
		67975,
		[
			7975
		]
	],
	"./pages/doctor-feedback.json": [
		76601,
		[
			6601
		]
	],
	"./pages/for-pharmacies.json": [
		59951,
		[
			9951
		]
	],
	"./pages/gonorrhea.json": [
		89021,
		[
			9021
		]
	],
	"./pages/health-check-online.json": [
		53425,
		[
			3425
		]
	],
	"./pages/immune-system-test.json": [
		12476,
		[
			2476
		]
	],
	"./pages/medication-delivery.json": [
		45794,
		[
			5794
		]
	],
	"./pages/mens-health.json": [
		33242,
		[
			3242
		]
	],
	"./pages/mental-health-care-plans.json": [
		77405,
		[
			9786
		]
	],
	"./pages/online-medical-certificates-employers.json": [
		85635,
		[
			5635
		]
	],
	"./pages/pages.json": [
		38092,
		[]
	],
	"./pages/pharmacy-registration.json": [
		72113,
		[
			2113
		]
	],
	"./pages/pregnancy-planning-test.json": [
		13714,
		[
			3714
		]
	],
	"./pages/syphilis.json": [
		66173,
		[
			6173
		]
	],
	"./pages/telehealth-consultations.json": [
		74561,
		[
			4561
		]
	],
	"./pages/tiredness-test.json": [
		19536,
		[
			9536
		]
	],
	"./pages/treatment-plans.json": [
		94677,
		[
			4677
		]
	],
	"./pages/troubleshooting.json": [
		32478,
		[
			2478
		]
	],
	"./static_pages/StaticPages.json": [
		96133,
		[
			6133
		]
	],
	"./static_pages/treatment.json": [
		84395,
		[
			4395
		]
	],
	"./treatment/treatment-lite.json": [
		4055,
		[]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	const e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	const ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(() => (__webpack_require__.t(id, 3 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 42179;
module.exports = webpackAsyncContext;